export default "/images/ed1adc2b40d0501786367db996ec148b.png";